<div #wrapperRef>
  <video
    #videoElement
    autoplay
    muted
    playsinline
    [attr.controls]="type !== 'LIVE_VIEW' ? true : null"
    class="video-player"></video>
  <!-- Spinner chỉ hiển thị khi loaded = false và type = LIVE_VIEW -->
  <div class="spinner-overlay" *ngIf="type === 'LIVE_VIEW' && !loaded">
    <div class="spinner"></div>
  </div>
</div>
